import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars, faFilter, faKeyboard, faMagic } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TranslationKey, useTranslator } from '@Localization';
import { Button, Dropdown, Menu, MenuButton, MenuItem } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { useCustomHotkeys } from '../../../../common/hooks/useCustomHotkeys';
import { FiltersContainer } from '../../projectDetails/sub/images/containers/filters/FiltersDropdown.container';
import { BackToProjectContainer } from '../containers/BackToProject.container';
import { ShortcutsGuide } from './ShortcutsGuide';

library.add(faMagic);

interface IAnnotationMoreOptionsProps {
  globalShortcuts: { label: TranslationKey; keys: string[] }[];
  create?: boolean;
  review?: boolean;
  correct?: boolean;
  edit?: boolean;
  isFreeAccess?: boolean;
}

export const AnnotationMoreOptions = observer((props: IAnnotationMoreOptionsProps): ReactElement => {
  const { t } = useTranslator();

  const [isShortcutsGuideOpen, setIsShortcutsGuideOpen] = useState(false);
  const toggleShortcuts = (): void => {
    setIsShortcutsGuideOpen((prevState) => !prevState);
  };

  const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false);
  const toggleFilters = (): void => {
    setIsFiltersModalOpen((prevState) => !prevState);
  };

  useCustomHotkeys('?', toggleShortcuts, { ignoreModifiers: true }, [toggleShortcuts]);

  return (
    <>
      <Dropdown>
        <MenuButton
          slots={{ root: Button }}
          tabIndex={-1}
          slotProps={{ root: { variant: 'topbar', color: 'neutral' } }}
        >
          <FontAwesomeIcon icon={faBars} />
        </MenuButton>
        <Menu>
          <BackToProjectContainer />
          {props.isFreeAccess && (
            <MenuItem onClick={toggleFilters}>
              <FontAwesomeIcon icon={faFilter} /> {t('image_filters.active_filters')}
            </MenuItem>
          )}
          <MenuItem onClick={toggleShortcuts}>
            <FontAwesomeIcon icon={faKeyboard} /> {t('shortcuts')}
          </MenuItem>
        </Menu>
      </Dropdown>

      {props.isFreeAccess && (
        <FiltersContainer
          isOpen={isFiltersModalOpen}
          toggle={toggleFilters}
        />
      )}
      <ShortcutsGuide
        isOpen={isShortcutsGuideOpen}
        toggle={toggleShortcuts}
        edit={props.edit}
        review={props.review}
        create={props.create}
        correct={props.correct}
        globalShortcuts={props.globalShortcuts}
        isFreeAccess={props.isFreeAccess}
      />
    </>
  );
});
